import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import SEOMeta from "@/components/SEOMeta";
import { ArrowRight } from "lucide-react";

const suggestedLinks: { to: string; label: string; sub: string }[] = [
  {
    to: "/automacao-empresarial",
    label: "Automação empresarial",
    sub: "CRM, atendimento e gestão integrada",
  },
  { to: "/projetos", label: "Cases", sub: "Projetos entregues com resultado medido" },
  { to: "/contato", label: "Agendar diagnóstico gratuito", sub: "30 minutos, sem compromisso" },
];

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-background px-6 pb-16 pt-[70px]">
      <SEOMeta
        title="Página não encontrada"
        description="A página que você procura não existe ou foi movida."
        canonicalUrl={location.pathname}
      />
      <Helmet>
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <div className="mx-auto w-full max-w-[520px] text-center">
        <p className="font-display text-[78px] font-bold leading-none tracking-[-.06em] text-primary">
          404
        </p>
        <h1 className="mt-2.5 font-display text-2xl font-bold tracking-[-.03em] text-foreground">
          Essa página não existe
        </h1>
        <p className="mt-2.5 text-[14.5px] leading-[1.65] text-muted-foreground">
          Talvez o link tenha mudado. Estes são os caminhos mais usados:
        </p>

        <div className="mt-[26px] flex flex-col gap-2.5 text-left">
          {suggestedLinks.map(({ to, label, sub }) => (
            <Link
              key={to}
              to={to}
              className="group flex items-center gap-3.5 rounded-[13px] border border-border bg-card px-[18px] py-[15px] transition-colors hover:bg-muted"
            >
              <span className="min-w-0 flex-1">
                <span className="block text-[13.5px] font-bold text-foreground">{label}</span>
                <span className="mt-0.5 block text-[11.5px] text-muted-foreground">{sub}</span>
              </span>
              <ArrowRight className="h-4 w-4 shrink-0 text-primary transition-transform group-hover:translate-x-0.5" />
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NotFound;
